import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { clsx } from 'clsx'

import { LinkButton, PrimaryButton } from 'Components/_theme'
import { ReportItemStatusEnum } from 'Components/DownloadDataErasureReportsCard/DownloadDataErasureReportsCard.types'
import type { DownloadDateErasureReportsCardActionsProps } from 'Components/DownloadDataErasureReportsCard/DownloadDateErasureReportsCardActions.types'

import type { getReportStatus_getReportStatus_reports } from 'Constants/graphql/queries/detail/__generated__/getReportStatus'

export const DownloadDateErasureReportsCardActions = (
  props: DownloadDateErasureReportsCardActionsProps,
) => {
  const {
    isExpandable,
    isExpanded,
    toggleExpand,
    isDownloadAllAvailable,
    hasPendingReports,
    downloadAllReportItem,
    onReportDownload,
    onReportRequest,
  } = props

  const handleDownloadAllClick = useCallback(
    (report: getReportStatus_getReportStatus_reports) => {
      if (report.status === ReportItemStatusEnum.NOT_AVAILABLE) {
        onReportRequest(report.year)
      }

      if (report.status === ReportItemStatusEnum.AVAILABLE) {
        onReportDownload(report.url)
      }
    },
    [onReportDownload, onReportRequest],
  )

  return (
    <div
      className={clsx('d-flex gap-4 mt-4 align-items-center', {
        'justify-content-between': isExpandable,
        'justify-content-end': !isExpandable,
      })}
    >
      {isExpandable && (
        <LinkButton
          iconRight={isExpanded ? faChevronUp : faChevronDown}
          onClick={toggleExpand}
        >
          <FormattedMessage
            id={
              isExpanded
                ? 'DownloadDataErasureReportsCard_collapse'
                : 'DownloadDataErasureReportsCard_expand'
            }
          />
        </LinkButton>
      )}

      {isDownloadAllAvailable && (
        <PrimaryButton
          appearance="fill"
          disabled={hasPendingReports}
          isLoading={
            downloadAllReportItem?.status === ReportItemStatusEnum.PENDING
          }
          onClick={() =>
            downloadAllReportItem &&
            handleDownloadAllClick(downloadAllReportItem)
          }
        >
          <FormattedMessage
            id={
              downloadAllReportItem?.status === ReportItemStatusEnum.PENDING
                ? 'Preparing'
                : 'DownloadDataErasureReportsCard_download_all'
            }
          />
        </PrimaryButton>
      )}
    </div>
  )
}
